import { createContext } from 'react';


const MapContext = createContext();
const { Provider } = MapContext;

export { Provider };
export default MapContext;
